const contentLock = [
  "M9.27 5.76a4.3 4.3 0 0 0-2.62 0V4.25a1.31 1.31 0 0 1 2.62 0zm-.75 4.05v.81a.56.56 0 1 1-1.12 0v-.81a.75.75 0 0 1-.19-.5.75.75 0 0 1 1.5 0c0 .19-.07.36-.19.5zm1.87-3.49V4.25a2.44 2.44 0 0 0-2.43-2.43 2.44 2.44 0 0 0-2.44 2.43v2.07a4.3 4.3 0 0 0-1.87 3.55 4.31 4.31 0 0 0 4.3 4.31 4.31 4.31 0 0 0 4.32-4.3 4.3 4.3 0 0 0-1.88-3.56zM0 5a.73.73 0 0 1 .73-.72h2.9a.73.73 0 0 1 0 1.45H.74A.73.73 0 0 1 0 5zM11.64 5a.73.73 0 0 1 .72-.72h2.91a.73.73 0 0 1 0 1.45h-2.9a.73.73 0 0 1-.73-.73z"
];
export {
  contentLock
};
//# sourceMappingURL=contentLock.js.map
